/*
 *
 * Loader
 *
 */

import React from "react";
import {
  LoaderOverlay,
  LoaderWrapper,
  LoaderWrapperOverlay,
} from "./styledComponents";

const Loader = ({ color, size = "small", isOverlay = false }) => {
  return isOverlay ? (
    <LoaderOverlay>
      <LoaderWrapperOverlay color={color} size={size}>
        <div />
        <div />
        <div />
        <div />
      </LoaderWrapperOverlay>
    </LoaderOverlay>
  ) : (
    <LoaderWrapper color={color} size={size}>
      <div />
      <div />
      <div />
      <div />
    </LoaderWrapper>
  );
};

export default Loader;
